import ObjectCache from './CacheService';
import LogicBaseStoriesApi from '../server/LogicBaseStoriesApi';
import UserAccount from '../UserAccount';
import LogicBaseStory from '../../models/logicbasestory';

class LogicBaseStoriesCache extends ObjectCache {
  api = LogicBaseStoriesApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseStory(results._id, results.o, results.l, results.t, results.d, results.ct, results.error);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}

const singleton = new LogicBaseStoriesCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
